'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["validCountries", "optionsFilter", "multi", "enableSelectAll"];
import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { getCountryOptions, getOptionsForValidCountries } from '../internal/utils/getCountryOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const CountrySelect = props => {
  const {
      validCountries,
      optionsFilter,
      multi,
      enableSelectAll
    } = props,
    passThroughProps = _objectWithoutPropertiesLoose(props, _excluded);
  const options = validCountries ? getOptionsForValidCountries({
    validCountries,
    optionsFilter
  }) : getCountryOptions({
    optionsFilter
  });
  const optionsWithSelectAll = [{
    text: I18n.text('i18nAddon.selectAllOptions'),
    selectAll: true,
    options
  }];
  return /*#__PURE__*/_jsx(Select, Object.assign({
    "data-test-id": "country-select-input"
  }, passThroughProps, {
    multi: enableSelectAll || multi,
    anchorType: "button",
    options: enableSelectAll ? optionsWithSelectAll : options
  }));
};
export default CountrySelect;